// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  firebase: {
    projectId: 'd-enotarylog-core',
    appId: '1:375041708896:web:fd81149a74a6de7cadc405',
    databaseURL: 'https://d-enotarylog-core.firebaseio.com',
    storageBucket: 'd-enotarylog-core.appspot.com',
    locationId: 'us-east4',
    apiKey: 'AIzaSyCBvOfkTmIqSKVGuxjr0o8m-3bpfA0Z31k',
    authDomain: 'd-enotarylog-core.firebaseapp.com',
    messagingSenderId: '375041708896',
    measurementId: 'G-J4QTEVF01L',
  },
  production: false,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
